// created by AI

export enum OilAndGasFieldType {
	OIL = "Oil",
	GAS = "Gas",
	"OIL/GAS" = "Oil/Gas",
	"GAS/CONDENSATE" = "Gas/Condensate",
}

export type OilAndGasFieldArea = {
	fldNpdidField: string
	wlbNpdidWellbore: string
	fldName: string
	fldCurrentActivitySatus: string
	wlbName: string
	fldDiscoveryYear: string
	fldFactPageUrl: string
	fldFactMapUrl: string
	fldOwnerKind: string
	fldOwnerName: string
	cmpLongName: string
	wlbFactPageUrl: string
	fldHcType: keyof typeof OilAndGasFieldType | ""
	fldMainArea: string
	cmpNpdidCompany: string
	fldNpdidOwner: string
	fldDateUpdated: string
	fldDateUpdatedMax: string
	fldMainSupplyBase: string
	fldAreaGeometryWKT: (number[][] | number[][][])[]
}
